import React, { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

const styles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: "75%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export default function RegularModal({
  title,
  onClose,
  open,
  children,
  style,
}) {
  return (
    <>
      <Modal open={!!open} onClose={onClose}>
        <Box sx={{ ...styles, ...style }}>
          <Typography variant="h6">{title && title}</Typography>
          {children}
        </Box>
      </Modal>
    </>
  );
}
